import { render, staticRenderFns } from "./SwitchToHistoryLink.vue?vue&type=template&id=881bbf16&scoped=true"
import script from "./SwitchToHistoryLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchToHistoryLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SwitchToHistoryLink.vue?vue&type=style&index=0&id=881bbf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881bbf16",
  null
  
)

export default component.exports